import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pega-compass",
  "use": "pega-compass-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"pega-compass\"><g fill=\"var(--bolt-theme-icon, currentColor)\"><path d=\"M16 1.1A14.9 14.9 0 1031 16 15 15 0 0016 1.1zM16 29a13 13 0 1113.1-13A13 13 0 0116 29zM22.1 8.6L13 12.4a1 1 0 00-.5.5l-3.9 9.2a1 1 0 00.2 1.1 1 1 0 00.7.3 1 1 0 00.4 0l9.3-3.9a1 1 0 00.5-.5l3.9-9.2a1 1 0 00-1.4-1.3zM18 17.9L14.1 14l6.5-2.7z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol